declare global {
  // noinspection JSUnusedGlobalSymbols
  interface Window {
    ReactNativeWebView?: {
      postMessage(msg: string): void;
    };
  }
}

export type ExpoMessage =
  | ExpoMessageEnablePushNotificationsReq
  | ExpoMessageWriteLogReq
  | ExpoMessageOpenUrlReq;

export type ExpoMessageEnablePushNotificationsReq = {
  type: 'enable-push-notifications-req';
};

export type ExpoMessageWriteLogReq = {
  type: 'write-log-req';
  message: string;
};

export type ExpoMessageOpenUrlReq = {
  type: 'open-url-req';
  url: string;
};

export const ExpoUtils = {
  sendMessageToExpo: (message: ExpoMessage) => {
    const postMessage = window.ReactNativeWebView?.postMessage;
    if (!postMessage) return;
    postMessage(JSON.stringify(message));
  },
};
